exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".model-close-btn[data-v-0ab60b54]{position:absolute;right:15px;top:10px;font-size:25px;color:#2c3e50;text-decoration:none}", "", {"version":3,"sources":["/Users/trungnq/Code/ksk/sns/public/pwa/src/components/modal-notification.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,eAAgB,AAChB,cAAe,AACf,oBAAsB,CACvB","file":"modal-notification.vue","sourcesContent":["\n.model-close-btn[data-v-0ab60b54] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  font-size: 25px;\n  color: #2c3e50;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ab60b54","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal-notification.vue
// module id = 816
// module chunks = 0